import desk from "../../assets/images/404.webp";
import phone from "../../assets/images/404phone.webp";
import Shared from "../Static/Shared/Shared";
import apple from "../../assets/images/home/apple.webp";
import insta from "../../assets/images/home/insta.webp";
import linked from "../../assets/images/home/linked.webp";
import store from "../../assets/images/home/store.webp";
import { useNavigate } from "react-router-dom";
function NotFoundComp() {
  const navigate = useNavigate();
  return (
    <>
      <div className="text-decoration pb-5 ">
        <div className="position-relative">
          <img
            src={desk}
            alt="brand category"
            className="w-100 d-lg-block d-none"
          />

          <img
            src={phone}
            alt="brand category"
            className="w-100 d-lg-none d-block"
          />
          <div className="align-items-center d-flex justify-content-end ps-5 pt-4 pt-md-0 position-btn2 ">
            <div>
              <div>
                <a
                  href="https://www.linkedin.com/company/libasuae"
                  aria-label="Visit Libas UAE LinkedIn Company Page"
                >
                  <img
                    src={linked}
                    alt="social"
                    className="homepage-icon img-fluid"
                  />
                </a>
              </div>
              <div className="pt-lg-4 pb-lg-4 pt-1 pb-1">
                <a
                  href="https://www.instagram.com/libasluxury/?igshid=YmMyMTA2M2Y%3D"
                  aria-label="Visit Libas Luxury Instagram Profile"
                >
                  <img
                    src={insta}
                    className="homepage-icon img-fluid"
                    alt="social"
                  />
                </a>
              </div>
              <div>
                <a
                  href="https://apps.apple.com/app/libas-uae/id1605637445"
                  aria-label="Download Libas App on the Apple App Store"
                >
                  <img
                    src={apple}
                    className="homepage-icon img-fluid"
                    alt="social"
                  />
                </a>
              </div>
              <div className="pt-lg-4 pb-lg-4 pt-1 pb-1">
                <a
                  href="https://play.google.com/store/apps/details?id=com.libas.libas"
                  aria-label="Download Libas App on Google Play Store"
                >
                  <img
                    src={store}
                    className="homepage-icon img-fluid"
                    alt="social"
                  />
                </a>
              </div>
            </div>
          </div>

          <div className="btn404-pos text-center ">
            <div>
              <button
                className="btn404"
                onClick={() => {
                  navigate("/");
                }}
              >
                return home
              </button>
            </div>
          </div>
        </div>
      </div>
      <Shared />
    </>
  );
}

export default NotFoundComp;
